(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["winding-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  function planWinding(cart, config, enabled) {
    const wanted = {};
    let eligible = 0;
    for (const item of cart.items) {
      const service = config.mapping[item.variant_id];
      if (service) {
        eligible += item.quantity;
        if (enabled) wanted[service] = (wanted[service] || 0) + item.quantity;
      }
    }
    const updates = {};
    const additions = [];
    const claimed = new Set();
    let manual = false;
    for (const item of cart.items) {
      if (!config.serviceIds.includes(item.variant_id)) continue;
      if (item.properties?._ww_winding !== 'all_eligible') { manual = true; continue; }
      const quantity = claimed.has(item.variant_id) ? 0 : (wanted[item.variant_id] || 0);
      claimed.add(item.variant_id);
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    for (const [id, quantity] of Object.entries(wanted)) {
      if (!claimed.has(Number(id))) additions.push({ id: Number(id), quantity, properties: { _ww_winding: 'all_eligible' } });
    }
    const unavailable = Object.keys(wanted).some((id) => !config.services[id]?.available);
    return { wanted, eligible, updates, additions, manual, unavailable };
  }

  function windingQuote(wanted, services, locale, currency) {
    const formatter = new Intl.NumberFormat(locale || 'en', { style: 'currency', currency });
    const prices = Object.keys(wanted).map((id) => services[id]?.price).filter((price) => Number.isFinite(price));
    const subtotal = Object.entries(wanted).reduce((sum, [id, qty]) => sum + (services[id]?.price || 0) * qty, 0);
    const minimum = prices.length ? Math.min(...prices) : 0;
    const maximum = prices.length ? Math.max(...prices) : 0;
    const unit = minimum === maximum ? formatter.format(minimum / 100) : `${formatter.format(minimum / 100)}–${formatter.format(maximum / 100)}`;
    return { unit, subtotal: formatter.format(subtotal / 100) };
  }

  class WindingController {
    constructor(config, events) {
      this.config = config;
      this.events = events;
      this.cart = null;
      this.busy = false;
      this.error = false;
      this.requested = undefined;
      this.pending = 0;
      this.needsRefresh = false;
      this.queue = Promise.resolve();
      document.addEventListener('change', (event) => {
        if (!event.target.matches('[data-winding-toggle]')) return;
        this.requested = event.target.checked;
        this.enqueue();
      });
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-winding-retry]')) this.enqueue();
      });
      document.addEventListener(events.StandardEvents.cartLinesUpdate, (event) => {
        if (this.dispatching) return;
        this.enqueue(event.promise);
      });
      const blockWhileUpdating = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const checkout = target?.closest('.cart__ctas, [name="checkout"], a[href*="/checkout"]') || event.submitter?.name === 'checkout';
        if ((this.busy && target?.closest('cart-items-component, product-form-component, form[action*="/cart"]')) || ((this.busy || this.error) && checkout)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      document.addEventListener('click', blockWhileUpdating, true);
      document.addEventListener('submit', blockWhileUpdating, true);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') blockWhileUpdating(event);
      }, true);
      new MutationObserver(() => this.paint()).observe(document.body, { childList: true, subtree: true });
      window.addEventListener('pageshow', (event) => { if (event.persisted) this.enqueue(); });
      this.enqueue();
    }

    enqueue(pending) {
      this.pending += 1;
      this.busy = true;
      this.paint();
      this.queue = this.queue.then(async () => {
        if (pending) await pending.catch(() => undefined);
        await this.sync();
      }).catch(() => { this.error = true; }).finally(() => {
        this.pending -= 1;
        this.busy = this.pending > 0;
        this.paint();
      });
    }

    async request(endpoint, body) {
      const options = { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' };
      if (body) { options.method = 'POST'; options.body = JSON.stringify(body); }
      const response = await fetch(`${window.Shopify.routes.root}cart${endpoint}.js`, options);
      const data = await response.json();
      if (!response.ok || data.errors) throw new Error('Winding cart request failed');
      return data;
    }

    enabled(cart = this.cart) {
      return this.requested ?? (cart?.attributes?.['Winding service'] === 'All eligible yarn');
    }

    async sync() {
      this.cart = await this.request('');
      const enabled = this.enabled();
      const plan = planWinding(this.cart, this.config, enabled);
      if (enabled && (plan.manual || plan.unavailable)) throw new Error('Winding cannot be applied');
      let changed = false;
      if (Object.keys(plan.updates).length) {
        this.needsRefresh = true;
        this.cart = await this.request('/update', { updates: plan.updates });
        changed = true;
      }
      if (plan.additions.length) {
        this.needsRefresh = true;
        await this.request('/add', { items: plan.additions });
        changed = true;
      }
      const value = enabled && plan.eligible > 0 ? 'All eligible yarn' : '';
      if ((this.cart.attributes?.['Winding service'] || '') !== value || changed) {
        this.cart = await this.request('/update', { attributes: { 'Winding service': value } });
        changed = true;
      }
      const verification = planWinding(this.cart, this.config, value !== '');
      if (verification.additions.length || Object.keys(verification.updates).length) throw new Error('Winding cart verification failed');
      this.requested = undefined;
      if (this.needsRefresh) {
        await this.refresh();
        this.needsRefresh = false;
      }
      this.error = false;
    }

    async refresh() {
      const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))].slice(0, 5);
      const url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart display refresh failed');
      const sections = await response.json();
      if (ids.some((id) => !sections[id])) throw new Error('Cart section missing');
      const { CartLinesUpdateEvent } = this.events;
      const event = new CartLinesUpdateEvent({
        action: 'update', context: 'cart', lines: [],
        promise: Promise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(this.cart),
          detail: { sections, items: this.cart.items, itemCount: this.cart.item_count, source: 'ww-winding' },
        }),
      });
      this.dispatching = true;
      try { document.dispatchEvent(event); } finally { this.dispatching = false; }
    }

    paint() {
      document.documentElement.toggleAttribute('data-winding-busy', this.busy);
      document.documentElement.toggleAttribute('data-winding-error', this.error);
      document.querySelectorAll('.cart__ctas').forEach((el) => { el.inert = this.busy || this.error; });
      if (!this.cart) {
        document.querySelectorAll('ww-winding-control').forEach((control) => {
          control.hidden = !this.error;
          control.querySelector('[data-winding-toggle]').disabled = true;
          const status = control.querySelector('[data-winding-status]');
          if (status.textContent !== this.config.strings.error) status.textContent = this.config.strings.error;
          control.querySelector('[data-winding-retry]').hidden = !this.error || this.busy;
        });
        return;
      }
      const plan = planWinding(this.cart, this.config, true);
      const enabled = this.enabled();
      const quote = windingQuote(plan.wanted, this.config.services, document.documentElement.lang, this.cart.currency);
      const text = this.config.strings;
      const status = this.busy ? text.updating : this.error ? text.error : plan.manual ? text.manual : plan.unavailable ? text.unavailable : '';
      const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
      document.querySelectorAll('ww-winding-control').forEach((control) => {
        control.hidden = !plan.eligible && !enabled && !this.error;
        const input = control.querySelector('[data-winding-toggle]');
        input.checked = enabled;
        input.disabled = this.busy || (!enabled && (plan.manual || plan.unavailable || !plan.eligible));
        input.setAttribute('aria-invalid', String(this.error));
        setText(control.querySelector('[data-winding-label]'), text.label.replace('__price__', quote.unit));
        setText(control.querySelector('[data-winding-fee]'), text.fee.replace('__amount__', quote.subtotal));
        setText(control.querySelector('[data-winding-status]'), status);
        control.querySelector('[data-winding-retry]').hidden = !this.error || this.busy;
      });
    }
  }

  import('@shopify/events').then((events) => {
    const config = document.getElementById('ww-winding-config');
    if (config && !window.wwWindingController) window.wwWindingController = new WindingController(JSON.parse(config.textContent), events);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
